var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.113 15.073H10.2V13.5c0-.994.92-1.8 1.913-1.8a1.686 1.686 0 1 1 0 3.373Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 2a1 1 0 0 1 2 0v1h6V2a1 1 0 1 1 2 0v1h.5a4 4 0 0 1 4 4v11.5a4 4 0 0 1-4 4h-11a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4H7V2Zm0 3.5v-.627H6a1.5 1.5 0 0 0-1.5 1.5V8.25h15V6.373a1.5 1.5 0 0 0-1.5-1.5h-1V5.5a1 1 0 1 1-2 0v-.627H9V5.5a1 1 0 0 1-2 0Zm5.113 4.8c-1.767 0-3.313 1.433-3.313 3.2v2.273c0 1.893 1.42 3.427 3.313 3.427h1.823a.7.7 0 1 0 0-1.4h-1.823c-.873 0-1.504-.553-1.79-1.327h1.79a3.086 3.086 0 1 0 0-6.173Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.9281086c980c1535926e16254ac1e048.svg";
export { ForwardRef as ReactComponent };